import { useEffect } from "react";
import { DashboardLayout } from "../../components/DashboardLayout";
import { ProfileContent } from "../../components/ProfileContent";
import { ADMIN_MENU } from "../../lib/menus";

export default function AdminProfile() {
  useEffect(() => { document.title = "Profil Admin - DS KODE"; }, []);
  return (
    <DashboardLayout title="Profil Admin" menu={ADMIN_MENU} testid="admin-profile">
      <ProfileContent />
    </DashboardLayout>
  );
}
